import Invest from '@/components/Invest';
import Layout from '@/components/Layout';

// Заглушка для переводов
const translate = s => s;

const InvestPage = ({ data }) => {
    return <Invest data={data} />;
};

export async function getStaticProps() {
    const data = {
        cooperation: {
            title: 'Открыты к сотрудничеству',
            text: 'Группа «Юнифрост» открыта к сотрудничеству с компаниями пищевой, перерабатывающей и логистической отраслей России и СНГ. Мы стремимся выстраивать долгосрочные партнерские отношения, способствующие устойчивому развитию, инновациям и росту всей отрасли.'
        },
        priorities: {
            title: 'Наши приоритеты',
            blocks: [
                {
                    title: 'Стратегические альянсы',
                    description: 'Развитие стратегических альянсов с компаниями, работающими в сфере рыболовства, аквакультуры, переработки, производства замороженных и консервированных продуктов, детского и функционального питания, готовых блюд, а также современных логистических комплексов.'
                },
                {
                    title: 'Ценность качества',
                    description: 'Поддержка проектов, разделяющих ценности эффективности, качества, безопасности продукции и ответственного отношения к окружающей среде.'
                },
                {
                    title: 'Инновационная среда',
                    description: 'Формирование прозрачной, инновационной бизнес-среды, открытой для внедрения современных технологий и обмена опытом.'
                },
                {
                    title: 'Развитие рынка',
                    description: 'Вклад в развитие продовольственного рынка России и стран СНГ за счет внедрения передовых решений и создания новых возможностей для производителей.'
                },
                {
                    title: 'Качество для потребителя',
                    description: 'Создание и продвижение решений, которые помогают предоставлять потребителю широкий выбор качественных, безопасных и современных продуктов питания.'
                },
            ],
            lastBlock: {
                title: 'Стратегические альянсы',
                description: `<ul>
                    <li>Рыболовство (компании с квотами на водные биоресурсы)</li>
                    <li>Рыбопереработка</li>
                    <li>Аквакультура и марикультура</li>
                    <li>Консервное производство (рыбные, мясные, плодоовощные консервы)</li>
                    <li>Замороженные мясные и куриные полуфабрикаты</li>
                    <li>Замороженные овощи, фрукты, ягоды</li>
                    <li>Морозильные склады и специализированные транспортные компании по логистике замороженных и охлажденных грузов</li>
                    <li>Плодоовощная консервация, производство соков, фруктового и овощного детского питания</li>
                    </ul>`
            },
            text: `Группа «Юнифрост» не пользуется услугами инвестиционных брокеров, инвестиционных посредников. Прямой контакт по инвестиционным предложениям <a href="mailto:invest@unifrost.ru">invest@unifrost.ru</a>`
        },
        criteria: {
            title: 'Критерии отбора партнёров',
            listing: [
                {
                    title: 'Ориентация на взаимовыгодное развитие и укрепление позиций на рынке.',
                    description: 'Взаимовыгодное развитие'
                },
                {
                    title: 'Прозрачность финансовых операций и управленческих процессов.',
                    description: 'Прозрачность'
                },
                {
                    title: 'Эффективное использование инвестиций, внимательное отношение к финансовой устойчивости и возможностям дальнейшего роста.',
                    description: 'Эффективность'
                },
                {
                    title: 'Готовность к совместному внедрению лучших практик корпоративного управления и инновационных решений.',
                    description: 'Инновации'
                },
                {
                    title: 'Соответствие высоким стандартам деловой этики, законодательства и комплаенса, репутация надежного работодателя и партнёра.',
                    description: 'Этика и репутация'
                },
            ]
        },
        honesty: {
            title: 'Честное, открытое и долгосрочное сотрудничество',
            text: 'Мы убеждены, что только через честное, открытое и долгосрочное сотрудничество можно добиться максимально положительного эффекта — как для наших партнёров, так и для потребителей и всей отрасли в целом.'
        },
    };

    return {
        props: {
            data
        }
    };
}

const breadcrumbs = [
    { title: translate('Главная'), route: '/' },
    { title: translate('Инвестиционная политика Группы «Юнифрост»'), route: '/invest' },
];

InvestPage.getLayout = (page, t) => (
    <Layout page={page.props} breadcrumbs={breadcrumbs} title={t('Инвестиционная политика — UNIFROST')}>
        {page}
    </Layout>
);

export default InvestPage;
